<div class="rs-padding-left3-m" *ngIf="isDisneyPlusProduct">
  <ng-container *ngIf="shouldActivatePlan; else addressSection">
    <div class="rs-flex-row rs-flex-dir-col-small-only">
      <div class="rs-flex-column">
        <ng-container *ngTemplateOutlet="addressSection"></ng-container>
      </div>

      <div class="rs-flex-column">
        <div class="rs-block">
          <div *ngIf="isPlanEligible" class="rs-status rs-warning">
            <ng-container
              *ngTemplateOutlet="notActivatedWarningLabel"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngTemplateOutlet="pxAlert"></ng-container>

  <div
    *ngIf="isSubscriptionActive"
    class="rs-flex-row rs-flex-dir-col-small-only"
  >
    <div class="rs-flex-columns rs-order-m2">
      <ng-container *ngIf="!isPlanActive; else watchSection">
        <mprd-disney-plus-order-button
          *ngIf="isPlanEligible"
          [buttonType]="OrderButtonType.ACTIVATE"
        ></mprd-disney-plus-order-button>
      </ng-container>
    </div>
    <div class="rs-flex-columns rs-order-m1">
      <mprd-disney-plus-order-button
        *ngIf="!environmentService.isSmoothAccess"
        [buttonType]="OrderButtonType.CEASE"
      ></mprd-disney-plus-order-button>
    </div>
  </div>

  <div class="rs-pickx">
    <div class="rs-ctable rs-ctable-highlight rs-margin-top2">
      <div class="rs-flex-row">
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-has-overlap rs-maxh">
            <div class="rs-panel-flex">
              <div
                class="rs-panel-flex-cell rs-bg-pickx rs-border-c2 rs-flex rs-flex-dir-col"
              >
                <div
                  *ngIf="!isSubscriptionActive"
                  class="rs-patch-recommended rs-patch-recommended-full-so rs-patch-recommended-full-m rs-is-overlapping"
                >
                  <div class="rs-patch-content">
                    {{
                      "option.details.disneyplus.recommended.banner" | translate
                    }}
                  </div>
                </div>
                <div class="rs-flex-grow">
                  <h3 class="rs-ctable-panel-title rs-padding-top1">
                    {{ "option.details.disneyplus.standard.title" | translate }}
                  </h3>
                  <ul
                    [innerHTML]="
                      'option.details.disneyplus.standard.content' | translate
                    "
                  ></ul>
                </div>
                 <p
                  class="text-center"
                  [innerHtml]="
                    'option.details.disneyplus.standard.priceContent' | translate
                  "
                ></p>
               

                <mprd-disney-plus-order-button
                  *ngIf="
                    !isSubscriptionActive && !environmentService.isSmoothAccess
                  "
                  [buttonType]="OrderButtonType.ORDER_STANDARD"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="isSubscriptionActive && isStandardPlan && isPlanActive"
                  [buttonType]="OrderButtonType.ACTIVE"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="
                    isSubscriptionActive &&
                    isPremiumPlan &&
                    !environmentService.isSmoothAccess
                  "
                  [buttonType]="OrderButtonType.DOWNGRADE"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="isStandardPlan && shouldActivatePlan && isPlanEligible"
                  [buttonType]="OrderButtonType.ACTIVATE"
                ></mprd-disney-plus-order-button>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-has-overlap rs-maxh">
            <div class="rs-panel-flex">
              <div
                class="rs-panel-flex-cell rs-bg-pickx rs-border-c2 rs-flex rs-flex-dir-col"
              >
                <div class="rs-flex-grow">
                  <h3 class="rs-ctable-panel-title rs-padding-top1">
                    {{ "option.details.disneyplus.premium.title" | translate }}
                  </h3>
                  <ul
                    [innerHTML]="
                      'option.details.disneyplus.premium.content' | translate
                    "
                  ></ul>
                </div>
                 <p
                  class="text-center"
                  [innerHtml]="
                    'option.details.disneyplus.premium.priceContent' | translate
                  "
                ></p>
              

                <mprd-disney-plus-order-button
                  *ngIf="
                    !isSubscriptionActive && !environmentService.isSmoothAccess
                  "
                  [buttonType]="OrderButtonType.ORDER_PREMIUM"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="
                    isSubscriptionActive &&
                    isStandardPlan &&
                    !environmentService.isSmoothAccess
                  "
                  [buttonType]="OrderButtonType.UPGRADE"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="isSubscriptionActive && isPremiumPlan && isPlanActive"
                  [buttonType]="OrderButtonType.ACTIVE"
                ></mprd-disney-plus-order-button>

                <mprd-disney-plus-order-button
                  *ngIf="isPremiumPlan && shouldActivatePlan && isPlanEligible"
                  [buttonType]="OrderButtonType.ACTIVATE"
                ></mprd-disney-plus-order-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p
    *ngIf="!isSubscriptionActive || (isPremiumPlan && isPlanActive)"
    class="rs-txt-s3"
  >
    {{ "option.details.disneyplus.premium.info" | translate }}
  </p>
</div>

<div class="rs-padding-left3-m" *ngIf="isPickXDisneyPlusProduct">
  <p id="isSubscriptionActiveNotActive" *ngIf="!isSubscriptionActive">
    <mprd-address [address]="address" [showInOneLine]="true"></mprd-address>
  </p>

  <ng-container *ngTemplateOutlet="pxAlert"></ng-container>

  <div
    *ngIf="isSubscriptionActive"
    class="rs-flex-row rs-flex-dir-col-small-only"
  >
    <div class="rs-flex-column">
      <p id="address">
        <mprd-address [address]="address" [showInOneLine]="true"></mprd-address>
      </p>
    </div>

    <div *ngIf="isPlanActive" class="rs-flex-column rs-flex-shrink">
      <div class="rs-block">
        <div class="rs-status rs-success">
          <i class="rs-status-icon" aria-hidden="true"></i>Active
        </div>
      </div>
    </div>

    <div *ngIf="shouldActivatePlan" class="rs-flex-column">
      <div class="rs-block">
        <div *ngIf="isPlanEligible" class="rs-status rs-warning">
          <ng-container
            *ngTemplateOutlet="notActivatedWarningLabel"
          ></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isSubscriptionActive">
    <a
      href="https://www.netflix.com/"
      target="_blank"
      class="rs-inline-block rs-link-neg rs-margin-bottom2 rs-margin-right2"
      >Manage Netflix<span class="rs-icon-link-tb" title="New window"
        ><span class="show-for-sr">New window</span></span
      ></a
    >
    <a
      href="https://www.disneyplus.com/"
      target="_blank"
      *ngIf="!shouldActivatePlan"
      class="rs-inline-block rs-link-neg rs-margin-bottom2 rs-margin-right2"
      >Watch Disney+<span class="rs-icon-link-tb" title="New window"
        ><span class="show-for-sr">New window</span></span
      ></a
    >
    <a
      href="https://www.pickx.be/"
      target="_blank"
      *ngIf="!shouldActivatePlan"
      class="rs-inline-block rs-link-neg rs-margin-bottom2"
      >Watch Pickx<span class="rs-icon-link-tb" title="New window"
        ><span class="show-for-sr">New window</span></span
      ></a
    >
  </div>

  <div class="rs-flex-row rs-flex-dir-col-small-only">
    <div class="rs-flex-columns">
      <mprd-disney-plus-order-button
        *ngIf="!isSubscriptionActive && !environmentService.isSmoothAccess"
        [buttonType]="OrderButtonType.PACK_ORDER"
      ></mprd-disney-plus-order-button>

      <mprd-disney-plus-order-button
        *ngIf="isSubscriptionActive && shouldActivatePlan && isPlanEligible"
        [buttonType]="OrderButtonType.ACTIVATE"
        [buttonClass]="shouldActivatePlan ? 'rs-btn-nl' : ''"
      ></mprd-disney-plus-order-button>

      <mprd-disney-plus-order-button
        *ngIf="isSubscriptionActive && !environmentService.isSmoothAccess"
        [buttonType]="OrderButtonType.CEASE"
        [buttonClass]="isPremiumPlan ? 'rs-btn-nl-m' : ''"
      ></mprd-disney-plus-order-button>
    </div>
    <div class="rs-flex-columns">
      <mprd-disney-plus-order-button
        *ngIf="!isSubscriptionActive && !environmentService.isSmoothAccess"
        [buttonType]="OrderButtonType.PACK_ORDER_PREMIUM"
      ></mprd-disney-plus-order-button>

      <mprd-disney-plus-order-button
        *ngIf="
          isSubscriptionActive &&
          isStandardPlan &&
          !environmentService.isSmoothAccess
        "
        [buttonType]="OrderButtonType.PACK_UPGRADE_PREMIUM"
      ></mprd-disney-plus-order-button>
    </div>
  </div>

  <div>
    <mprd-disney-plus-order-button
      *ngIf="isPremiumPlan && !environmentService.isSmoothAccess"
      [buttonType]="OrderButtonType.PACK_DOWNGRADE"
    ></mprd-disney-plus-order-button>
  </div>

  <div>
    <button
      class="rs-btn rs-btn-third rs-btn-neg"
      data-reveal-id="disneyPremium"
    >
      {{
        "option.details.disneyplus.compareDisneyPlusVersionBtnLabel"
          | translate
      }}<i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
    </button>

    <div
      aria-labelledby="ac-disneyPremium-label"
      class="reveal-modal rs-reveal-modal-neg"
      data-reveal=""
      id="disneyPremium"
      role="dialog"
      style="display: none; opacity: 1; visibility: hidden; top: -477.822px"
      [innerHTML]="
        'tv.active.options.disneyplus.differenceDisneyPremiumlabel' | translate
      "
    ></div>
  </div>
</div>

<ng-template #watchSection>
  <mprd-disney-plus-order-button
    [buttonType]="OrderButtonType.WATCH"
  ></mprd-disney-plus-order-button>
</ng-template>

<ng-template #addressSection>
  <p id="target">
    <mprd-address [address]="address" [showInOneLine]="true"></mprd-address>
  </p>
</ng-template>

<ng-template #notActivatedWarningLabel>
  <i class="rs-status-icon" aria-hidden="true"></i
  >{{ "tv.active.options.disneyplus.notactivated" | translate }}
</ng-template>

<ng-template #pxAlert>
  <px-alert *ngIf="alertKey" [alertKey]="alertKey"></px-alert>
  <px-alert *ngIf="netflixAlertKey" [alertKey]="netflixAlertKey"></px-alert>
</ng-template>

